document.addEventListener('DOMContentLoaded', () => {
	const STEP = 3;

	document.querySelectorAll('.work-slider-wrap').forEach((wrap) => {
		const track = wrap.querySelector('.work-slider');
		const prevBtn = wrap.querySelector('.work-slider-prev');
		const nextBtn = wrap.querySelector('.work-slider-next');
		if (!track) return;

		const originalItems = Array.from(track.children);
		if (originalItems.length === 0) return;

		// Loop illusion: duplicate the full set on both ends, so scrolling past
		// either edge lands on identical-looking content, then silently jump
		// back by one set-width once the scroll settles.
		const cloneSet = () =>
			originalItems.map((item) => {
				const clone = item.cloneNode(true);
				clone.setAttribute('aria-hidden', 'true');
				clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
				return clone;
			});

		cloneSet().forEach((clone) => track.insertBefore(clone, track.firstChild));
		cloneSet().forEach((clone) => track.appendChild(clone));

		const getSetWidth = () => {
			const firstOriginal = track.children[originalItems.length];
			const firstClone = track.children[0];
			return firstOriginal.getBoundingClientRect().left - firstClone.getBoundingClientRect().left;
		};

		track.scrollLeft = getSetWidth();

		const scrollByCards = (direction) => {
			const card = track.querySelector('li');
			if (!card) return;
			const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
			const cardWidth = card.getBoundingClientRect().width + gap;
			track.scrollBy({ left: cardWidth * STEP * direction, behavior: 'smooth' });
		};

		let settleTimer;
		track.addEventListener('scroll', () => {
			clearTimeout(settleTimer);
			settleTimer = setTimeout(() => {
				const setWidth = getSetWidth();
				if (track.scrollLeft >= setWidth * 2) {
					track.scrollLeft -= setWidth;
				} else if (track.scrollLeft <= 0) {
					track.scrollLeft += setWidth;
				}
			}, 120);
		});

		prevBtn?.addEventListener('click', () => scrollByCards(-1));
		nextBtn?.addEventListener('click', () => scrollByCards(1));
	});
});
